import React from 'react'
import {
  Button,
  colors,
  Grid,
  H3,
  H4,
  LayoutBand,
  Paragraph,
  Row,
  Separator,
  usePageWidth,
  WhiteTheme,
} from '@fs/zion-ui'

import CatalogoViewer from './CatalogoViewer'
import constants from '../../../../../../utils/constants'

export default function CatalogoSection({ surname, catalogoData }) {
  const atWidth = usePageWidth()
  const isMobile = atWidth({ default: true, lg: false })
  const isDesktop = atWidth({ default: false, xl: true })

  let catalogoLink = '/library/books/idurl/1/812684'

  if (catalogoData) {
    const catalogoPageInFinder = catalogoData.url.match(/\/(\d+)\.jpg$/)
    if (catalogoPageInFinder) {
      catalogoLink = `/library/books/viewer/812684/?offset=0#page=${catalogoPageInFinder[1]}&viewer=picture&o=search&n=0&q=${surname}`
    }
  }

  return (
    <LayoutBand maxWidth="md" color={colors.gray02} marginY="lg">
      <Grid gutters={isDesktop ? 'xxl' : 'lg'}>
        <div columns={isMobile ? 12 : 7} alignY="middle">
          <H3 supplementary>
            Your Surname Was{catalogoData ? ' ' : "n't "} Found in the <i>Catálogo Alfabético de Apellidos</i>
          </H3>
          <Separator size="lg" />
          <div>
            <H4>
              What is the <i>Catálogo</i>?
            </H4>
            <Separator size="xs" />
            <Paragraph size="sm">
              In 1849, Governor-General Clavería decreed that all Filipino families must have surnames. These surnames
              were distributed regionally from a list called the <i>Catálogo Alfabético de Apellidos</i>.
            </Paragraph>
          </div>
          <Separator size="md" />
          <div>
            <H4>How can I determine my ancestry?</H4>
            <Separator size="xs" />
            <Paragraph size="sm">
              The <i>Catálogo Alfabético de Apellidos</i> alone can&apos;t determine your ancestry. The best way to
              discover ancestry is to build your family tree and trace your roots. You can also search for your
              ancestors in the FamilySearch ancestor database.
            </Paragraph>
          </div>
          <Separator size="md" />
          <Row wrap>
            <Button
              emphasis="high"
              to={constants.URL_LOGIN_CONNECT_TO_TREE}
              external
              linkName="Link:Get Started | Guided Tree:Link"
              color="gray"
              fullWidth={isMobile}
              growX={isMobile}
            >
              Start My Family Tree
            </Button>
            <Button
              emphasis="medium"
              to={catalogoLink}
              external
              linkName="Link:Go to Catalogo:Click"
              color="gray"
              fullWidth={isMobile}
              growX={isMobile}
            >
              View Catálogo
            </Button>
          </Row>
        </div>
        <div columns={isMobile ? 12 : 5} alignY="middle">
          <WhiteTheme>
            <CatalogoViewer catalogoData={catalogoData} />
          </WhiteTheme>
        </div>
      </Grid>
    </LayoutBand>
  )
}
